export enum Step {
  SEARCH_FIRMS = 0,
  REGISTER_FIRM = 1,
  DUE_DILIGENCE = 2,
  PERSONAL_DETAILS = 3,
  VERIFICATION = 4,
}
